import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import information from '@/pages/information'
import technics from '@/pages/technics'
import risk from '@/pages/risk'
import train from '@/pages/train'
import finance from '@/pages/finance'
import tenancy from '@/pages/tenancy'
import company from '@/pages/company'
import companyinfo from '@/pages/companyinfo'
import login from '@/pages/login'
import personal from '@/pages/personal'
import system from '@/pages/system/system'
import warning from '@/pages/system/systemitem/warning'
import companylist from '@/pages/system/systemitem/companylist'
import applylist from '@/pages/system/systemitem/applylist'
import account from '@/pages/system/systemitem/account'
import policydetail from '@/pages/policydetail'
import techdetail from '@/pages/techdetail'
import risklist from '@/pages/risklist'
import traindetail from '@/pages/traindetail'
import riskdetail from '@/pages/riskdetail'
import financedetail from '@/pages/financedetail'
import comdetail from '@/pages/comdetail'
import search from '@/pages/search'
import otherwarning from '@/pages/system/systemitem/otherwarning'
import tenancydetail from '@/pages/tenancydetail'
import concat_us from '@/pages/mine/concat_us'
import service from '@/pages/mine/service'
import apply from '@/pages/mine/apply'
import room_price from '@/pages/mine/room_price'
import service_price from '@/pages/mine/service_price'
import payment_way from '@/pages/mine/payment_way'
import service_list from '@/pages/mine/service_list'
import company_brief from '@/pages/mine/company_brief'
import company_list from '@/pages/company_list'
import searchpage from '@/pages/searchpage'
import latestpolicy from '@/pages/latestpolicy'
import noticelist from '@/pages/noticelist'
// company_list
 
Vue.use(Router)
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
	{
	  path: '/noticelist',
	  name: 'noticelist',
	  component: noticelist
	},
    {
      path: '/information',
      name: 'information',
      component: information
    },
    {
      path: '/technics',
      name: 'technics',
      component: technics
    },
    {
      path: '/risk',
      name: 'risk',
      component: risk
    },
    {
      path: '/train',
      name: 'train',
      component: train
    },
    {
      path: '/finance',
      name: 'finance',
      component: finance
    },
    {
      path: '/tenancy',
      name: 'tenancy',
      component: tenancy
    },
    {
      path: '/company',
      name: 'company',
      component: company
    },
    {
      path: '/companyinfo',
      name: 'companyinfo',
      component: companyinfo
    },{
      path: '/searchpage',
      name: 'searchpage',
      component: searchpage
    }, 
		{
		  path: '/latestpolicy',
		  name: 'latestpolicy',
		  component: latestpolicy
		}, 
		 
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/personal',
      name: 'personal',
      component: personal,
      children: [
        {
          path: '/concat_us',
          name: 'concat_us',
          component: concat_us
        },{
          path: '/service',
          name: 'service',
          component: service
        },{
          path: '/apply',
          name: 'apply',
          component: apply
        },{
          path: '/room_price',
          name: 'room_price',
          component: room_price
        },{
          path: '/service_price',
          name: 'service_price',
          component: service_price
        },{
          path: '/payment_way',
          name: 'payment_way',
          component: payment_way
        },{
          
          path: '/service_list',
          name: 'service_list',
          component: service_list
        },{
          
          path: '/company_brief',
          name: 'company_brief',
          component: company_brief
        }
    ]
    },
    {
      path: '/policydetail',
      name: 'policydetail',
      component: policydetail
    },
    {
      path: '/company_list',
      name: 'company_list',
      component: company_list
    },
    {
      path: '/techdetail',
      name: 'techdetail',
      component: techdetail
    },
    {
      path: '/risklist',
      name: 'risklist',
      component: risklist
    },
    {
      path: '/traindetail',
      name: 'traindetail',
      component: traindetail
    },
    {
      path: '/riskdetail',
      name: riskdetail,
      component: riskdetail
    },
    {
      path: '/financedetail',
      name: financedetail,
      component: financedetail
    },
    {
      path: '/comdetail',
      name: comdetail,
      component: comdetail
    },
    {
      path: '/search',
      name: search,
      component: search
    },
    {
      path: '/tenancydetail',
      name: tenancydetail,
      component: tenancydetail
    },
    {
      path: '/system',
      name: 'system',
      component: system,
      children: [
          {
              path: '/warning',
              name: 'warning',
              component: warning
          },
          {
            path: '/companylist',
            name: 'companylist',
            component: companylist
          },
          {
            path: '/applylist',
            name: 'applylist',
            component: applylist
          },
          {
            path: '/account',
            name: 'account',
            component: account
          },
          {
            path: '/otherwarning',
            name: 'otherwarning',
            component: otherwarning
          }
      ]
    }

  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js